<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ក ៥.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៥.គ ៥.ឃ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៥.ង​ ៥.ច
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៥.ឆ​ ៥.ជ,ញ,ដ,ឋ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <emisbuilding :data="fac_5bn" :title="title[10]"/>
          </div>
          <div class="row">
            <div>
              <schoolroom :data="fac_5cc" title=""/>
            </div>
            <div>
              <roomfac :data="fac_5cn" :title="title[11]" />
            </div>
            <!-- No title on the form -->
          </div>          
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolarea :data="fac_5a" :last_row="0" :title="title[12]" />
          </div>
          <div>
            <handwashing :data="utl_5d" :lastRow="1" :title="title[13]" />
            <!-- LastRow is 1 for pri and sec school-->
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div>
          <toilet :data="utl_5e" :title="title[14]" />
          <water :data="utl_5f" :title="title[15]" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div>
          <facility :data1="utl_g1" :data2="utl_g2" :title="title[16]" />
          <schoolsport :fdata="utl_5h1" :sdata="utl_5h2" :title="title[18]" />
        </div>
        <div>
          <giga :data="giga" :title="title[17]"/>
        </div>
        <div>
          <schdormitory :data="edbt" :title="title[19]"/>
          <schbudinternet :data="idbt" :title="title[20]"/>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import schoolArea from "@/components/ascf/sharedCom/schoolArea.vue";
import schoolConst from "@/components/ascf/sharedCom/schoolConstruction.vue";
import schoolRoom from "@/components/ascf/sharedCom/schoolRoom.vue";
import handWashing from "@/components/ascf/sharedCom/handwashing.vue";
import toilet from "@/components/ascf/sharedCom/toilet.vue";
import Facility from "@/components/ascf/sharedCom/facility.vue";
import WaterSource from "@/components/ascf/sharedCom/waterSource.vue";
import schoolSport from "@/components/ascf/sharedCom/schoolSport.vue";
import emis_building from "@/components/ascf/sharedCom/emis_building.vue";
import roomfac from "@/components/ascf/sharedCom/emis_facilities.vue";
import giga from "@/components/ascf/sharedCom/giga.vue";
import schDormitory from "@/components/ascf/sharedCom/schDormitory.vue";
import schBudInternet from "@/components/ascf/sharedCom/schBudInternet.vue";

export default {
  props: [
    "title",
    "fac_5a",
    "fac_5b",
    "fac_5bn",
    "fac_5c",
    "fac_5cn",
    "fac_5cc",
    "utl_5d",
    "utl_5e",
    "utl_5f",
    "utl_g1",
    "utl_g2",
    "utl_5h1",
    "utl_5h2",
    "giga",
    "edbt",
    "idbt",
    "lst_acc",
  ],
  components: {
    schoolarea: schoolArea,
    schoolroom: schoolRoom,
    handwashing: handWashing,
    toilet: toilet,
    facility: Facility,
    water: WaterSource,
    schoolsport: schoolSport,
    emisbuilding: emis_building,
    roomfac: roomfac,
    giga: giga,
    schdormitory: schDormitory,
    schbudinternet: schBudInternet
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.col {
  display: flex;
  flex-direction: column;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>